var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#09090B",
    stroke: "#CDCDD6",
    strokeWidth: 1.125,
    d: "M9 1.583c4.524 0 7.418 3.709 7.418 7.417 0 3.71-2.894 7.418-7.418 7.418-2.04 0-3.749-.755-5.01-1.923l-.246-.24a7.6 7.6 0 0 1-1.448-2.089l-.146-.332a.04.04 0 0 1 0-.028l.02-.02a.04.04 0 0 1 .029 0l.02.02a7.5 7.5 0 0 0 1.33 2.132l.249.266c1.267 1.29 3.047 2.138 5.202 2.138 4.477 0 7.342-3.668 7.343-7.342 0-3.673-2.866-7.342-7.343-7.342-3.666 0-5.457 2.727-6.18 4.077l-.443.828H5.4a.037.037 0 0 1 0 .074H2.218l.671-1.183C3.705 4.016 5.514 1.583 9 1.583Zm.038 4.98v4.875h-.075V6.563zM1.8 2.963c.02 0 .038.017.038.037v3.637H1.8a.037.037 0 0 1-.038-.037V3c0-.02.017-.037.038-.038Z"
  })));
};
export default SvgReset;